import { __assign } from "tslib";
import * as parseColor from 'color';
function withWixRequired(Wix) {
    if (!Wix || !Wix.Styles) {
        throw new Error("\nWix is required to get default params.\nGet default params for color or font is possible only at Widget Settings iframe.\n  ");
    }
}
function getWixColor(Wix, reference, opacity) {
    if (opacity === void 0) { opacity = 1; }
    withWixRequired(Wix);
    var wixColor = Wix.Styles.getSiteColors(function () { }).find(function (c) { return c.reference === reference; });
    var parsedColor = parseColor(wixColor.value);
    return {
        opacity: opacity,
        value: parsedColor
            .rgb()
            .alpha(opacity)
            .string(),
        name: wixColor.name,
    };
}
// Inspired by: https://github.com/wix-private/ecom/blob/e057721e6e654b324dc2c41f434e85b6307546fb/client/settings-editor-common-components/src/utils/fontUtils.ts#L51-L80
function getFontFromPreset(presetName, textPresets) {
    if (!textPresets[presetName]) {
        return null;
    }
    var preset = textPresets[presetName];
    return {
        size: parseInt(preset.size, 10),
        family: preset.fontFamily,
        preset: presetName,
        style: {
            bold: preset.weight === 'bold',
            italic: preset.style === 'italic',
            underline: false,
        },
        fontStyleParam: false,
        value: preset.value,
    };
}
function getWixFont(Wix, name, textPresets) {
    withWixRequired(Wix);
    return getFontFromPreset(name, textPresets);
}
export var searchResultsStyles = {
    searchBarBackgroundColor: {
        type: 4 /* Color */,
        name: 'searchBarBackgroundColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-1');
        },
    },
    searchBarBorderWidth: {
        type: 0 /* Number */,
        name: 'searchBarBorderWidth',
        getDefaultValue: function () { return 1; },
    },
    searchBarBorderColor: {
        type: 4 /* Color */,
        name: 'searchBarBorderColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5', 0.6);
        },
    },
    searchBarTextFont: {
        type: 3 /* Font */,
        name: 'searchBarTextFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Body-M', textPresets)), { size: 20 }));
        },
    },
    searchBarTextFontColor: {
        type: 4 /* Color */,
        name: 'searchBarTextFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    searchBarIconColor: {
        type: 4 /* Color */,
        name: 'searchBarIconColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5', 0.6);
        },
    },
    // --
    resultsMenuTextFont: {
        type: 3 /* Font */,
        name: 'resultsMenuTextFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Body-M', textPresets)), { size: 16 }));
        },
    },
    resultsMenuTextFontColor: {
        type: 4 /* Color */,
        name: 'resultsMenuTextFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    resultsMenuBorderColor: {
        type: 4 /* Color */,
        name: 'resultsMenuBorderColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    resultsMenuSelectedBorderColor: {
        type: 4 /* Color */,
        name: 'resultsMenuSelectedBorderColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-8');
        },
    },
    resultsTitleFont: {
        type: 3 /* Font */,
        name: 'resultsTitleFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Heading-M', textPresets)), { size: 20 }));
        },
    },
    resultsTitleFontColor: {
        type: 4 /* Color */,
        name: 'resultsTitleFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    resultsDescriptionFont: {
        type: 3 /* Font */,
        name: 'resultsDescriptionFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Body-M', textPresets)), { size: 14 }));
        },
    },
    resultsDescriptionFontColor: {
        type: 4 /* Color */,
        name: 'resultsDescriptionFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    resultsMessageFont: {
        type: 3 /* Font */,
        name: 'resultsMessageFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Body-M', textPresets)), { size: 14 }));
        },
    },
    resultsMessageFontColor: {
        type: 4 /* Color */,
        name: 'resultsMessageFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    paginationTextFont: {
        type: 3 /* Font */,
        name: 'paginationTextFont',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix, textPresets = _a.textPresets;
            return (__assign(__assign({}, getWixFont(Wix, 'Body-M', textPresets)), { size: 16 }));
        },
    },
    paginationTextFontColor: {
        type: 4 /* Color */,
        name: 'paginationTextFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-5');
        },
    },
    paginationSelectedTextFontColor: {
        type: 4 /* Color */,
        name: 'paginationSelectedTextFontColor',
        getDefaultValue: function (_a) {
            var Wix = _a.Wix;
            return getWixColor(Wix, 'color-8', 0.6);
        },
    },
};
//# sourceMappingURL=index.js.map